<template>
	<div class="brand-list-container">
		<div class="top-content container">
			<div class="title font-34 uppercase bold">
				{{ _.get($store.state.main.selected_menu, 'title') }}
			</div>
			<div class="count light">{{ list_count }} {{ $fn.tr('მაღაზია') }}</div>
		</div>
		<transition name="toggleContent" mode="out-in">
			<div class="brand-list container" v-if="!load" key="0">
				<brand-card
					@click.native="openPopup(brand)"
					v-for="brand in brandList"
					:brand="brand"
					:key="brand.id"
				/>
				<!-- {{brandList}} -->
			</div>
			<div key="1" v-else class="brand-list-load container"></div>
		</transition>

		<div class="mall-pagination-container" v-if="list_count > per_page_count">
			<el-pagination
				class="pagination mall-pagination container"
				layout="prev,pager, next"
				:page-size="per_page_count"
				:current-page.sync="page"
				:total="list_count"
				:disabled="false"
				:hide-on-single-page="true"
				@current-change="sendData"
				:key="'pagination'"
			/>
		</div>
		<portal to="modal">
			<StorePopup v-if="$store.state.main.store_pop_up" />
		</portal>
	</div>
</template>

<script>
import BrandCard from './BrandCard.vue';
import fn from '../../helpers/func';
import OffersSlider from './OffersSlider.vue';
import StorePopup from '@/components/modals/StorePopup';

export default {
	components: { BrandCard, OffersSlider, StorePopup },
	props: ['contentData'],
	data() {
		return {
			page: 1,
			filteredList: null,
			load: false,
			_list_count: '',
			first_loaded: false,
		};
	},
	computed: {
		brandList() {
			if (this.filteredList) {
				let cleanData = this.filteredList.map((item) => {
					return { ...item, premium_sort: Number(item.premiumSort) };
				});
				return this.premium_checker ? _.sortBy(cleanData, 'premium_sort') : this.filteredList;
			} else {
				let cleanData = _.get(this.contentData, 'data.list').map((item) => {
					return { ...item, premium_sort: Number(item.premiumSort) };
				});

				return this.premium_checker
					? _.sortBy(cleanData, 'premium_sort')
					: _.get(this.contentData, 'data.list');
			}
		},
		premium_checker() {
			return this.$store.state.main.selected_menu.configs.includes('premium_space');
		},
		per_page_count() {
			return parseInt(_.get(this.contentData, 'conf.page_count'))
				? parseInt(_.get(this.contentData, 'conf.page_count'))
				: 8;
		},
		get_unic_id() {
			return _.get(this.contentData, 'conf.unicId');
		},
		store_type() {
			return _.get(this.contentData, 'conf.taxonomies.store_types');
		},
		store_category() {
			return _.get(this.contentData, 'conf.taxonomies.store_categories');
		},
		list_count() {
			if (this.filteredList) {
				return this._list_count;
			} else {
				return _.get(this.contentData, 'data.listCount');
			}
		},
		search_list() {
			return this.$store.state.main.search_list;
		},
		search_val() {
			return this.$store.state.main.search_typed;
		},
		search_terms() {
			return this.$store.state.main.search_val;
		},
		shop_suggestions() {
			return this.$store.state.main.shop_suggestions;
		},
		check_loading() {
			let arr = [this.per_page_count, this.$route, this.load];
			return arr;
		},
	},
	mounted() {
		this.load = true;
		if (!this.$route.query.page) {
			let _url = {
				path: '',
				query: {
					cat_id: 0,
					item_type: 0,
					page: 1,
				},
			};
			this.$router.push(_url);
		}
		setTimeout(() => {
			this.load = false;
		}, 1000);
	},
	methods: {
		openPopup(data) {
			this.$store.commit('main/setState', { key: 'store_pop_up', val: true });
			this.$store.commit('main/setState', {
				key: 'store_modal_data',
				val: data,
			});
		},

		async sendData() {
			this.load = true;
			let params;
			if (this.premium_checker) {
				let prem_label = this.$store.state.main.indx.terms.store_labels.filter(
					(lab) => lab.premium_tag && lab.premium_tag[0] == 'yes'
				)[0].id;

				params = {
					componentUnicId: this.get_unic_id,
					id: _.get(this.$store.state.main.selected_menu, 'id'),
					pageNumber: this.page,
					searchText: this.search_val,
					taxonomies: {
						project: this.contentData?.conf?.taxonomies?.project,
						store_types: this.contentData?.conf?.taxonomies?.store_types,
						store_categories: [this.search_terms],
						store_labels: [prem_label],
					},
					perPage: this.per_page_count,
					relations: this.shop_suggestions ? ['offers'] : '',
				};
			} else {
				params = {
					componentUnicId: this.get_unic_id,
					id: _.get(this.$store.state.main.selected_menu, 'id'),
					pageNumber: this.page,
					searchText: this.search_val,
					taxonomies: {
						project: this.contentData?.conf?.taxonomies?.project,
						store_types: this.contentData?.conf?.taxonomies?.store_types,
						store_categories: [this.search_terms],
					},
					perPage: this.per_page_count,
					relations: this.shop_suggestions ? ['offers'] : '',
				};
			}
			const res = await fn.postData('main/getDataList', params);

			this.filteredList = res.data.list || null;
			this._list_count = res.data.listCount;
			this.load = false;
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
	},
	watch: {
		search_list(ns, os) {
			this.filteredList = ns.data.list;
			this._list_count = ns.data.listCount;
		},
		search_val(ns, os) {
			this.page = 1;
			console.log(ns);
		},
		check_loading: {
			immediate: true,
			handler(ns, os) {
				// ESENI DASASRULEBELI MAQVS // DON'T REMOVE=

				console.log(ns[1].query.page);
				// console.log(parseInt(ns.query.page), this.page)
				if (ns[0] && ns[1].query.page && this.page !== parseInt(ns[1].query.page)) {
					this.page = parseInt(ns[1].query.page);
					// console.log(ns[1].query.page);
					// console.log(ns[0]);
					// console.log(ns[2]);
					setTimeout(() => {
						this.sendData();
						console.log('data sent #2');
						// this.first_loaded = true;
					}, 700);
					console.log('executed');
				}
			},
		},
		page(ns, os) {
			let _url;

			// console.log(this.$route.query.cat_id);
			// console.log(this.$route.query.item_type);
			if (this.$route.query.cat_id) {
				_url = {
					path: '',
					query: {
						cat_id: this.$route.query.cat_id,
						item_type: this.$route.query.item_type,
						page: ns,
					},
				};
			} else {
				_url = {
					path: '',
					query: { page: ns },
				};
			}
			console.log(ns, os);
			if (this.page !== parseInt(this.$route.query.page)) {
				this.$router.push(_url);
				console.log('hi');
			}
		},
		search_terms(ns, os) {
			if (this.$route.query.page) {
				// this.load = false;
				this.page = parseInt(this.$route.query.page);

				// setTimeout(() => {
				// if (this.first_loaded) {
				//   this.sendData();
				//   console.log("data sent #1");
				//   console.log(this.first_loaded)
				// }

				// this.load = true;
				// }, 200);
			} else {
				this.page = 1;
				console.log('reset');
			}
		},
		per_page_count(ns, os) {
			this.$store.commit('main/setState', {
				key: 'per_page',
				val: ns,
			});
		},
		get_unic_id: {
			immediate: true,
			handler(ns, os) {
				if (ns)
					this.$store.commit('main/setState', {
						key: 'unique_id',
						val: ns,
					});
			},
		},
		store_type: {
			immediate: true,
			handler(ns, os) {
				if (ns)
					this.$store.commit('main/setState', {
						key: 'store_type',
						val: ns,
					});
			},
		},
		store_category: {
			immediate: true,
			handler(ns, os) {
				if (ns)
					this.$store.commit('main/setState', {
						key: 'store_category',
						val: ns,
					});
			},
		},
		contentData: {
			immediate: true,
			handler(ns) {
				if (ns) {
					this.$store.commit('main/setState', {
						key: 'list_content_data',
						val: ns,
					});
				}
			},
		},
	},
};
</script>

<style lang="scss">
.brand-list-container {
	background: #f7f7f7;
	padding-bottom: 89px;
	@media (max-width: 767px) {
		padding-bottom: 55px;
	}
	.top-content {
		padding-top: 55px;
		padding-bottom: 55px;
		.title {
			margin-bottom: 12px;
		}
	}
	.brand-list {
		display: grid;
		grid-template-columns: repeat(3, minmax(0px, 1fr));
		grid-gap: 30px;

		@media (max-width: 1023px) {
			grid-template-columns: repeat(2, minmax(0px, 1fr));
			grid-gap: 15px;
		}
		@media (max-width: 767px) {
			grid-template-columns: repeat(1, minmax(0px, 1fr));
		}
	}
	.brand-list-load {
		min-height: 70vh;
	}
	.mall-pagination-container {
		padding-bottom: 0;

		.mall-pagination {
			padding: 0;
		}
	}
}
</style>
